import Item from './item';
import { h } from '../element';
import { cssPrefix } from '../../config';
import { SHEET_IMAGE_UPLOAD_UI } from '../../../../utils/spreadsheetImageHelpers';

const BUSY_CLASS = `${cssPrefix}-toolbar-insert-image-is-busy`;

/** Inline SVG (not sprite) — avoids clashing with undo/chart positions on sprite.svg */
const INSERT_IMAGE_SVG = encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#454545" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round"><rect x="3.25" y="5.25" width="17.5" height="13.5" rx="1.75"/><path d="M3.25 17.25 8.5 12l3.25 3.25L15.25 11.5l5.5 5.75" fill="none"/></svg>'
);

/** Toolbar control to insert a floating sheet image (same row as chart / freeze). */
export default class ImageInsert extends Item {
  constructor() {
    super('insert-image');
  }

  element() {
    const wrap = h('div', `${cssPrefix}-toolbar-insert-image-icon`);
    const loader = h('div', `${cssPrefix}-toolbar-insert-image-loader`);
    loader.child(h('span', `${cssPrefix}-toolbar-insert-image-spin`));
    const img = h('img')
      .attr('src', `data:image/svg+xml;charset=utf-8,${INSERT_IMAGE_SVG}`)
      .attr('alt', '')
      .attr('draggable', 'false');
    wrap.child(img).child(loader);

    const busyMsg = h('span', `${cssPrefix}-toolbar-insert-image-busy-msg`);

    const root = super.element().child(wrap).child(busyMsg);
    root.on('click', () => {
      if (root.hasClass(BUSY_CLASS)) return;
      this.change(this.tag);
    });

    const onUploadUi = (ev) => {
      const { active, message } = ev.detail || {};
      if (active) {
        root.addClass(BUSY_CLASS);
        if (message) {
          root.attr('title', message);
          busyMsg.html(message);
        }
      } else {
        root.removeClass(BUSY_CLASS);
        root.removeAttr('title');
        busyMsg.html('');
      }
    };
    window.addEventListener(SHEET_IMAGE_UPLOAD_UI, onUploadUi);

    return root;
  }

  setState(disabled) {
    this.el.disabled(disabled);
  }
}
